import Icon from '@material-ui/core/Icon';
import React from 'react';
import { JustifyContentValue } from 'styled-system';
import { FloatingdButton } from '~frontend-common/components/buttons';
import { Box } from '~frontend-common/components/ui';
import { styled } from '~ui-kit/styled-components';

interface NextButtonProps {
  disabled?: boolean;
  justify?: JustifyContentValue;
  loading?: boolean;
  onSubmit?: () => void;
  text?: string;
  id?: string;
}

export function NextButton({ disabled = false, justify = 'flex-end', loading = false, text, id }: NextButtonProps) {
  return (
    <Box justify={justify} width={['100%']}>
      <StyledButton color="primary" size="large" type="submit" isLoading={loading} disabled={disabled} id={id}>
        {text}
        <Icon>chevron_right</Icon>
      </StyledButton>
    </Box>
  );
}

export function NextButtonWithHandler({
  disabled = false,
  loading = false,
  justify = 'flex-end',
  text,
  id,
  onSubmit,
}: NextButtonProps) {
  return (
    <Box justify={justify} width={['100%']}>
      <StyledButton color="primary" size="large" isLoading={loading} disabled={disabled} onClick={onSubmit} id={id}>
        {text}
        <Icon>chevron_right</Icon>
      </StyledButton>
    </Box>
  );
}

const StyledButton = styled(FloatingdButton)`
  && {
    min-width: 112px;
    padding-top: 8px;
    padding-right: 24px;
    padding-bottom: 8px;
    padding-left: 24px;
    min-height: 40px;
  }
`;
